export class GeoApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Returns regulatory reference rows for the given jurisdiction codes
     * (e.g. US-TN, EU, FR). Account session required.
     */
    async getJurisdictionRequirements(jurisdictions) {
        const q = jurisdictions.map((c) => c.trim()).filter(Boolean).join(',');
        if (!q) {
            return { success: true, data: [] };
        }
        return this.client.get(`/api/geo/requirements?jurisdictions=${encodeURIComponent(q)}`);
    }
    /**
     * Returns all seeded jurisdictions that require age/ID verification (public, no session).
     */
    async getJurisdictionRequirementsCatalog() {
        return this.client.get('/api/geo/requirements/catalog');
    }
}
//# sourceMappingURL=geo-api.js.map